import React, { useState, useEffect } from "react";
import {ReactComponent as Logo} from '../assets/Group 2.svg';
import { Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import {ReactComponent as EyeSlash} from '../assets/eye-slash.svg';
import {ReactComponent as SEye} from '../assets/eye.svg';
import {ReactComponent as EmailI} from '../assets/email.svg';
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import "../App.css";
import "./HCss.css";

function Home() {
  const [emailActive, setEmailActive] = useState(false);
  const [passActive, setPassActive] = useState(false);
  const [showPassword, setShowPassword] = useState(true);
  const navigate = useNavigate();
  const [otpModalVisible, setOtpModalVisible] = useState(false);
  const [userId, setUserId] = useState("");
  const [otpInput, setOtpInput] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  // const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [step, setStep] = useState("");
  // const [loading, setLoading] = useState(false);

  const emailBox = () =>{
    setEmailActive(true);
    setPassActive(false);
  }
  const passBox = () =>{
    setEmailActive(false);
    setPassActive(true);
  }
  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  const [smallMedia, setSmallMedia] = useState(window.innerWidth <= 768); // Adjust breakpoint as needed
  useEffect(() => {
    const handleResize = () => {
        setSmallMedia(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

const fetchCsrfToken = async () => {
  const res = await axios.get("/api/csrf-token", {
    withCredentials: true
  });
//console.log("crf function call", res.data.csrfToken);
  return res.data.csrfToken;
};
// const signInFunc = async () => {
//   if (loading) return; // prevent double click

//   setLoading(true);

//   try {
//     const csrfToken = await fetchCsrfToken();
//     const captchaToken = await grecaptcha.execute("SITE_KEY", { action: "login" });

//     const res = await axios.post(
//       "/api/signin",
//       { email, password, captchaToken },
//       { withCredentials: true, headers: { "X-CSRF-Token": csrfToken } }
//     );

//     setUserId(res.data.userId);
//     setOtpModalVisible(true); // show OTP popup

//   } catch (err) {
//     alert(err.response?.data?.message || "Login failed");
//   } finally {
//     setLoading(false); // always stop loading
//   }
// };

const signInFunc = async () => {
  if (loading) return;

  setLoading(true);

  try {
    const csrfToken = await fetchCsrfToken();

    if (!window.grecaptcha) {
      throw new Error("reCAPTCHA not loaded");
    }

    const captchaToken = await window.grecaptcha.execute(
      "6LeqJy4sAAAAAIza9IFp_p2MvE4MzDZiEFc98dYT",
      { action: "login" }
    );

    const res = await axios.post(
      "/api/signin",
      { email, password, captchaToken },
      {
        withCredentials: true,
        headers: { "X-CSRF-Token": csrfToken }
      }
    );

    setUserId(res.data.userId);
    setOtpModalVisible(true);

  } catch (err) {
    alert(err.response?.data?.message || err.message || "Login failed");
  } finally {
    setLoading(false);
  }
};



// const handleVerifyOtp = async () => {
//   try {
//     const res = await axios.post("/api/verify-otp", { userId, otp: otpInput });
//     alert(res.data.message);
//     console.log(res.data, "login data");
//     const data = await res.json();
//     const user = data.user;
//     // if(res.data.message === "")
//       if (user.role_id === 1) {
//         sessionStorage.setItem('super', 'true'); // Add super = "true" to session storage
//       }else{
//         sessionStorage.setItem('super', 'false'); // Add super = "true" to session storage
//       }
//       sessionStorage.setItem('userData', JSON.stringify(user));
//       navigate('/details');
//     setOtpModalVisible(false);
//     // redirect to dashboard
//   } catch (err) {
//     alert(err.response?.data?.message || "OTP verification failed");
//   }
// };


const handleVerifyOtp = async () => {
  try {
    const csrfToken = await fetchCsrfToken();
    const res = await axios.post(
      "/api/verify-otp",
      { userId, otp: otpInput },
      { withCredentials: true, headers: { "X-CSRF-Token": csrfToken } }
    );

    // alert(res.data.message);
    // console.log(res.data, "login data");

    const user = res.data.user;

    if (user.role_id === 1) {
      sessionStorage.setItem('super', 'true');
    } else {
      sessionStorage.setItem('super', 'false');
    }

    sessionStorage.setItem('userData', JSON.stringify(user));
    setOtpModalVisible(false);
    setOtpInput("");
    navigate('/details');

  } catch (err) {
    alert(err.response?.data?.message || "OTP verification failed");
  }
};

const handleSendOtp = async () => {
  if (!email) {
    alert("Email required");
    return;
  }

  try {
    setLoading(true);

    const csrfToken = await fetchCsrfToken();

    const captchaToken = await window.grecaptcha.execute(
      "6LeqJy4sAAAAAIza9IFp_p2MvE4MzDZiEFc98dYT",
      { action: "reset_password" }
    );

    const res = await fetch("/api/reset-password", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken
      },
      body: JSON.stringify({ email, captchaToken })
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data.message);

    alert("OTP sent");
    setStep("OTP");

  } catch (err) {
    alert(err.message);
  } finally {
    setLoading(false);
  }
};


const handleResetPassword = async () => {
  if (!otp || !newPassword) {
    alert("OTP and new password required");
    return;
  }

  try {
    setLoading(true);

    const csrfToken = await fetchCsrfToken();

    const res = await fetch("/api/reset-password-verify", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken
      },
      body: JSON.stringify({
        email,
        otp,
        newPassword
      })
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data.message);

    alert("Password reset successful");
    setStep("EMAIL");
    setEmail("");
    setOtp("");
    setNewPassword("");
    setStep("");

  } catch (err) {
    alert(err.message);
  } finally {
    setLoading(false);
  }
};

  return (
    // <Container fluid  >
    <div className="full">
 <div className="total-p">
{/* <Col sm={12} md={6} lg={6} >  */}
 <div className="full-form">
<div className={` logoImage ${smallMedia ? '' : 'logoImage-2'}`} >
<Col sm={12} md={12} lg={12} > 
<div className={` loDiv ${smallMedia ? '':'loDiv-2'}`} 
style={{margin: otpModalVisible ? '15px' : ''}}
>
<Logo className="sp-icon"/>
</div>
</Col>
{/* <Col sm={12} md={7} lg={7} className="mx-auto">  */}
<div className={`full-session ${smallMedia ? '' : 'full-session-2'}`}
style={{display: otpModalVisible ? 'none' : ''}}
>
<Col sm={12} md={12} lg={12} style={{width: '100%'}}> 
<div className={` homeLogin ${smallMedia ? '' :'homeLogin-2'}`} >
   <div className={`Rectangle-5 ${ smallMedia ? '' : 'Rectangle-5-2'}`}>
   <div className={`left-session ${smallMedia ? '' : 'left-session-2'}`}></div>
   <div className={`session ${smallMedia ? '' : 'session-2'}`}>Sign in to Start your Session</div> 
   <div className={`right-session ${smallMedia? '' : 'right-session-2'}`}></div>
</div>
</div>
</Col>
<div className="center">
<Col sm={12} md={12} lg={12} > 
 <div className={`inputT shade ${smallMedia ? '' : 'inputT-2 adjust'}`}  style={{ position: 'relative' }}>
   <input type="email" onClick={emailBox} 
   onChange={(event) => setEmail(event.target.value)} 
   value={email} className={`inputBox  ${smallMedia ? '' : 'inputBox-2'}`}  placeholder="Email"/>
 <span
 className={`${smallMedia ? '' : 'iconss'}`}
     style={{
       position: 'absolute',
       top: '50%',
       width: smallMedia ? '22px' : '2.2vw',
       height: smallMedia ? '17px' : '1.7vw',
       right: smallMedia ? '25px' : '2.5vw',
       transform: 'translateY(-50%)',
       cursor: 'pointer',
     }}
   >
         <EmailI className={`${smallMedia ? '' : 'sp-icon'}`}/>
   </span>

 </div>
</Col>
<Col sm={12} md={12} lg={12}> 
 <div className={`inputT shade passT ${smallMedia ? '' : 'inputT-2 passT-2'}`} style={{ position: 'relative' }}>
   <input type={showPassword ? 'password' : 'text'} onClick={passBox} 
   onChange={(event) => setPassword(event.target.value)} 
   value={password} 
   className={`inputBox ${smallMedia ? '' : 'inputBox-2 adjust'}`}   placeholder="Password"/>
           <span
           className={`${smallMedia ? '' : 'iconss'}`}
     style={{
       position: 'absolute',
       top: '50%',
       width: smallMedia ? '23px' : '2.3vw',
       height: smallMedia ? '20px' : '2vw',
       right: smallMedia ? '25px' : '2.5vw',
       transform: 'translateY(-50%)',
       cursor: 'pointer',
     }}
     onClick={handleTogglePassword}
   >
   { showPassword ? <EyeSlash className={`${smallMedia ? '' : 'sp-icon'}`}/> : <SEye className={`${smallMedia ? '' : 'sp-icon'}`}/> }
   </span>
 </div>
</Col>
</div>
<div className="fogt-lnk"> <a onClick={() => setStep("EMAIL")}>Forgot Password?</a> </div>
<Col sm={12} md={12} lg={12}> 
<div className={`${smallMedia ? 'signInbtn inputT' : 'signInbtn-2 inputT-2'}`} onClick={signInFunc}>
 <div className={`${smallMedia ? "shadeTriangle" : "shadeTriangle-2"}`}></div>
 {/* <button className="btnText">Sign In</button> */}
 <button
  className="btnText"
  disabled={loading}
>
  {loading ? "Signing In..." : "Sign In"}
</button>
</div>
</Col>
</div>

{otpModalVisible && (
  <div 
  //  className="otp-modal"
  className={`full-session ${smallMedia ? '' : 'full-session-2'}`}
   >
   <Col sm={12} md={12} lg={12} style={{width: '100%'}}> 
<div className={` homeLogin ${smallMedia ? '' :'homeLogin-2'}`} >
   <div className={`Rectangle-5 ${ smallMedia ? '' : 'Rectangle-5-2'}`}>
   <div className={`left-session ${smallMedia ? '' : 'left-session-2'}`}></div>
    <div className={`session ${smallMedia ? '' : 'session-2'}`}>Enter OTP sent to your email</div>
    <div className={`right-session ${smallMedia? '' : 'right-session-2'}`}></div>
    </div>
</div>
</Col>
<div className="center">
<Col sm={12} md={12} lg={12} > 
 <div className={`inputT shade ${smallMedia ? '' : 'inputT-2 adjust'}`}  style={{ position: 'relative' }}>
    <input type="text" value={otpInput} onChange={e => setOtpInput(e.target.value)} 
    className={`inputBox  ${smallMedia ? '' : 'inputBox-2'}`}  
    placeholder="OTP"
    />
  </div>
</Col>
  </div>
<Col sm={12} md={12} lg={12}> 
<div className={`${smallMedia ? 'signInbtn inputT' : 'signInbtn-2 inputT-2'}`} onClick={handleVerifyOtp}>
 <div className={`${smallMedia ? "shadeTriangle" : "shadeTriangle-2"}`}></div>
    <button className="btnText" disabled={loading}>Verify OTP</button>
    </div>
</Col>
  </div>
)}

</div>
 </div>
</div>

{step === "EMAIL" && (
  <div className="ful-cont-rest">
    <div className="reset-inpts email-reset">
      <Col sm={12} md={12} lg={12} > 
      <div className={`inputT shade ${smallMedia ? '' : 'inputT-2 adjust'}`}  style={{ position: 'relative' }}>
          <input type="text" value={email} onChange={e => setEmail(e.target.value)} 
          className={`inputBox  ${smallMedia ? '' : 'inputBox-2'}`}  
          placeholder="Enter Your Email"
          />
        </div>
      </Col>
      <div className="reset-actn">
        <button onClick={handleSendOtp} disabled={loading} className={`editconst  ${smallMedia ? "editconst2" : "ed-sp"}`}>
          {loading ? 'Submitting...' : 'Submit'}
        </button>
        <button onClick={() => setStep("")} className={`editconst  ${smallMedia ? "editconst2" : "ed-sp"}`}>
          Close
        </button>
      </div>
    </div>
  </div>
)}

{step === "OTP" && (
  <div className="ful-cont-rest">
  <div className="reset-inpts">
    <Col sm={12} md={12} lg={12} > 
      <div className={`inputT shade ${smallMedia ? '' : 'inputT-2 adjust'}`}  style={{ position: 'relative' }}>
        <input type="text" value={otp} onChange={e => setOtp(e.target.value)} 
        className={`inputBox  ${smallMedia ? '' : 'inputBox-2'}`}  
        placeholder="Enter OTP"
        />
      </div>
    </Col>
    {/* <input value={otp} onChange={e => setOtp(e.target.value)} /> */}
    <Col sm={12} md={12} lg={12} > 
      <div className={`inputT shade ${smallMedia ? '' : 'inputT-2 adjust'}`}  style={{ position: 'relative' }}>
        <input type="text" value={newPassword} onChange={e => setNewPassword(e.target.value)} 
        className={`inputBox  ${smallMedia ? '' : 'inputBox-2'}`}  
        placeholder="New Password"
        />
      </div>
    </Col>
      <div className="reset-actn">
        <button onClick={handleResetPassword} disabled={loading} className={`editconst  ${smallMedia ? "editconst2" : "ed-sp"}`}>
          {loading ? 'Submitting...' : 'Submit'}
        </button>
        <button onClick={() => setStep("")} className={`editconst  ${smallMedia ? "editconst2" : "ed-sp"}`}>
          Close
        </button>
      </div>
  </div>
  </div>
)}
</div>
  );
}

export default Home;
